import cn from "classnames";
import { Icon } from "components/Icon";
import { Button } from ".";

export const EmailButton = ({
    email,
    onClick,
    className,
    isGuest,
}: {
    email: string;
    onClick: () => void;
    className?: string;
    isGuest?: boolean;
}) => (
    <Button
        variant="outline-secondary"
        className={cn("py-1 rounded-pill bg-transparent border shadow-sm fw-normal text-body mw-100 d-flex align-items-center", className)}
        onClick={onClick}
    >
        <Icon icon={["far", isGuest ? "id-badge" : "circle-user"]} />
        <span className="mx-2 text-truncate">{email}</span>
        <Icon icon={["far", "pen-to-square"]} className="text-primary" />
    </Button>
);
